<script setup>
const { $bus } = useNuxtApp();
const props = defineProps({
    opened: {
        type: Boolean,
        required: true,
    },
    classes: {
        type: String,
        required: false,
        default: '',
    },
});

// Emits
const emit = defineEmits(['close']);

// Events
const handleClose = () => {
    emit('close');
};

// Test
const closing = ref(false);
const bonusClasses = ref(false);

const addToBonus = (newClass, opening = true) => {
    const state = opening ? 'opening' : 'closing';
    const prefix = ` mess-modal-${state}-`;
    bonusClasses.value += prefix + newClass;
};

const removeFromBonus = (newClass, opening = true) => {
    const state = opening ? 'opening' : 'closing';
    const prefix = ` mess-modal-${state}-`;
    bonusClasses.value = bonusClasses.value.replace(prefix + newClass, '');
};

const triggerOpeningClasses = () => {
    addToBonus('active');
    addToBonus('from');

    setTimeout(() => {
        removeFromBonus('from');
        addToBonus('to');
    }, 16);

    setTimeout(() => {
        removeFromBonus('active');
        removeFromBonus('to');
    }, 400);
};

// Watchers
watch(() => props.opened, (value) => {
    if (value) {
        triggerOpeningClasses();
        $bus.emit('scroll-lock');
        window.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') {
                handleClose();
            }
        });
    } else {
        $bus.emit('scroll-unlock');

        window.removeEventListener('keydown', (e) => {
            if (e.key === 'Escape') {
                handleClose();
            }
        });
    }
});
</script>

<template>
    <Teleport to="body" v-if="opened || closing">
        <MessFocusTrap>
            <div class="mess-modal" :class="classes + ' ' + bonusClasses" @click.self="handleClose"
                v-if="opened || closing">
                <div class="body">
                    <button @click="handleClose" class="close">
                        <slot name="close" />
                    </button>
                    <slot name="content" />

                    <button @click="handleClose" class="close sr-only sr-focusable">Close Modal</button>
                </div>
            </div>
        </MessFocusTrap>
    </Teleport>
</template>

<style lang="scss">
.mess-modal {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99999;
    width: 100%;
    height: 100%;

    backdrop-filter: blur(5px);

    cursor: pointer;
    overflow-y: auto;

    .body {
        cursor: auto;
        position: relative;

        .close {
            position: absolute;
            top: 2rem;
            right: 2rem;
            background: transparent;
            border: none;
            cursor: pointer;
        }
    }
}

.mess-modal-opening- {
    &active {
        transition: 250ms ease-in-out;
        transform-origin: bottom center;
    }

    &from {
        opacity: 0;
        transform: scale(0.75);
    }

    &to {
        opacity: 1;
        transform: scale(1);
    }
}

.mess-modal-closing- {
    &active {
        transition: 250ms ease-in-out;
        transform-origin: bottom center;
    }

    &from {
        opacity: 1;
        transform: scale(1);
    }

    &to {
        opacity: 0;
        transform: scale(0.75);
    }
}
</style>
